/** Trailing meta - never repeat the title as a kind chip. */
export function sessionFileMetaLabel(file: {
  title: string
  kind: string
  meta?: string | null
  isMemory?: boolean
  isSoulStack?: boolean
}): string | null {
  if (file.meta) return file.meta
  if (file.isMemory || file.kind === 'session_memory') return null
  if (file.isSoulStack || file.kind === 'soul_stack') return null
  if (file.kind === 'pointer' || file.title.startsWith('Pointer:')) return 'pointer'
  if (file.kind === 'canvas') return 'draft'
  return null
}
